<template>
  <div class="view-content view3">
    <div class="left">
      <div class="title">{{ $t('让消费成为财富的起点') }}</div>
      <div class="text text-padding">NECO —— {{ $t('消费即拥有，分享即收益') }}。</div>
      <div class="label">—{{ $t('NECO 是一套基于 Web3 技术的智能电商基础设施，通过「消费即持股」机制，让每一位用户在购物时获得真实权益与长期回报。 在这里，消费者不只是用户，更是平台的拥有者和生态的建设者。') }}</div>
    </div>
    <div class="right">
      <img class="img" src="./img/1030/view3-1.png">
    </div>
  </div>
</template>

<script>
export default {
  name: 'view3',
  data () {
    return {
      
    }
  },
}
</script>

<style scoped>
@import "./css/index.css";
.view3 {
  /* justify-content: center; */
}
.view3 .label {
    padding-top: 0;
}
.view3 .label {
    padding-right: 200px;
    color: #fff;
}
.view3 .text-padding {
  padding: 30px 0 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/lobby/components1030/view3.vue